// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IuVvi","content":"styles_content__2BdRh"};